/**
 * 本项目缓存 / 本地存储命名空间。
 * 多项目共用同一套前端模板时，必须用独立前缀，避免 Cache / localStorage 串台。
 */
export const APP_NS = 'h7'

/** Service Worker CacheStorage 名称前缀（与 public/sw.js 保持一致） */
export const SW_CACHE_PREFIX = `${APP_NS}-static-`

/** 当前静态资源缓存名 */
export const SW_CACHE_NAME = `${SW_CACHE_PREFIX}v1`

/** 历史遗留、会与其它项目冲突的 Cache 名 */
export const LEGACY_SW_CACHE_NAMES = ['ysm-static-v1', 'ysm-static-v2']

/** API sessionStorage 前缀 */
export const API_CACHE_PREFIX = `${APP_NS}:api-cache:`

/** 鉴权 / 配置 localStorage 键 */
export const STORAGE_KEYS = {
  token: `${APP_NS}:user-token`,
  userInfo: `${APP_NS}:user-info`,
  vuex: `${APP_NS}:vuex`,
  webConfig: `${APP_NS}:web-config`,
  webConfigV2: `${APP_NS}:web-config:v2`,
  supportToken: `${APP_NS}:support_user_access_token`,
}

/** 旧项目共用键，启动时迁移到本项目键后删除，避免污染其它同域项目 */
export const LEGACY_STORAGE_KEYS = [
  'user-token',
  'user-info',
  'vuex',
  'web-config',
  'web-config:v2',
  'support_user_access_token',
]
